import { Injectable } from '@angular/core';
import { CandidateProfile } from '../../../core/models/candidate-profile.model';

@Injectable({
  providedIn: 'root'
})
export class CommonSessionService {

  public bookingId: number | null = null;
  public userId: number | null = null;
    public candidate: CandidateProfile | null = null;

  setSession(
    bookingId: number,
    userId: number
  ): void {

    this.bookingId = bookingId;
    this.userId = userId;

     console.log('Session stored:', {
      bookingId: this.bookingId,
      userId: this.userId
    });
  }

  getBookingId(): number | null {
    return this.bookingId;
  }

  getUserId(): number | null {
    return this.userId;
  }

  getSession(): {
    bookingId: number | null;
    userId: number | null;
  } {

    return {
      bookingId: this.bookingId,
      userId: this.userId
    };
  }

    // ==============================
  // CANDIDATE
  // ==============================

  setCandidate(candidate: CandidateProfile): void {

    this.candidate = candidate;

    console.log('Candidate stored in session:', this.candidate);
  }


  getCandidate(): CandidateProfile | null {

    return this.candidate;
  }

  clearSession(): void {

    this.bookingId = null;
    this.userId = null;
  }
}
